import { Label } from 'react-aria-components';
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';

type Item = {
  label: string;
  value: string;
};

type Props<T extends FieldValues> = {
  name: FieldPath<T>;
  label?: string;
  control: Control<T>;
  items: Item[];
  required?: boolean;
};

const RaddioButton = <T extends FieldValues>(props: Props<T>) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{ required: props.required }}
      render={({ field: { onChange, value } }) => (
        <div className="flex flex-col">
          {props.label && (
            <Label className="mb-2 text-base md:text-lg md:font-bold">{props.label}</Label>
          )}
          <div className="flex flex-row gap-2">
            {props.items.map((item) => (
              <div
                key={item.label}
                className="flex flex-row items-center space-x-2"
              >
                <input
                  type="radio"
                  id={props.name}
                  name={props.name}
                  value={item.value}
                  onChange={onChange}
                  checked={item.value === value}
                />
                <label htmlFor={item.label}>{item.label}</label>
              </div>
            ))}
          </div>
        </div>
      )}
    />
  );
};

export default RaddioButton;
